var $02ed0f44dca8e510$exports = {};
$02ed0f44dca8e510$exports = {
    "decrease": (args)=>`Samazin\u{101}\u{161}ana ${args.fieldLabel}`,
    "increase": (args)=>`Palielin\u{101}\u{161}ana ${args.fieldLabel}`,
    "numberField": `Skait\u{13C}u lauks`
};


export {$02ed0f44dca8e510$exports as default};
//# sourceMappingURL=lv-LV.mjs.map
